module.exports = __webpack_public_path__ + "static/media/pallet.468c9347.svg";